import React from 'react'

import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import BodyText from 'components/Luxkit/Typography/BodyText'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import {
  CruiseItem,
  FlightItem,
  LETripItem,
  TourItem,
} from 'tripPlanner/types/tripItem'
import {
  buildStandaloneFlightSearchURL,
  getTourV1DeepLinkURL,
} from 'tripPlanner/utils/bookmark/deepLink'

interface Props {
  item: Extract<LETripItem, CruiseItem | TourItem | FlightItem>
  deepLinkUrl: string
}

const UNSUPPORTED_ERR_MESSAGE =
  'Tour V2 & New Cruises do not have bundled flights'

function BookTourFlight(props: Props) {
  const { item, deepLinkUrl } = props

  const { closeModal, goBack } = useModalCallbacks()

  let unbundledText: string
  let unbundledURL: string

  if (item.type === 'TOUR' || item.type === 'CRUISE') {
    if (item.savedItemData.offerType !== 'cruise') {
      const data = structuredClone(item.savedItemData)
      delete data.flightBundle

      unbundledText = 'No, book tour only'
      unbundledURL = getTourV1DeepLinkURL(data)
    } else {
      throw new Error(UNSUPPORTED_ERR_MESSAGE)
    }
  } else {
    const data = structuredClone(item.savedItemData)
    delete data.tourBundle

    unbundledText = 'No, book flights only'
    unbundledURL = buildStandaloneFlightSearchURL(data)
  }

  return (
    <>
      <ModalHeader
        title="Book tour and flights package?"
        onBackButtonClick={goBack}
        onCloseButtonClick={closeModal}
      />
      <ModalBody>
        <ModalContent>
          <BodyText variant="large" as="p">
            You've added this order as a tour and flights package.
          </BodyText>
          <BodyText variant="large" as="p">
            Do you want to book these items together?
          </BodyText>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Yes, book tour and flights',
          to: deepLinkUrl,
        }}
        secondaryActionProps={{
          children: unbundledText,
          to: unbundledURL,
        }}
      />
    </>
  )
}

export default BookTourFlight
